
    
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OccasionFeaturedGuest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OccasionData"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredGuests"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserRank"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserLink"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserLogin"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBiography"},"directives":[]}]}}]}}]};
  

    
  var names = {};
  function unique(defs) {
    return defs.filter(function (def) {
      if (def.kind !== 'FragmentDefinition') return true;
      var name = def.name.value;
      if (names[name]) {
        return false;
      } else {
        names[name] = true;
        return true;
      }
    });
  };

  doc.definitions = doc.definitions.concat(unique(require("@aurora/shared-client/components/users/UserAvatar/UserAvatar.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@aurora/shared-client/components/users/UserRank/UserRank.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@aurora/shared-client/components/users/UserBiography/UserBiography.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@aurora/shared-client/components/users/UserLogin/UserLogin.fragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("@aurora/shared-client/components/users/UserLink/UserLink.fragment.graphql").definitions));


    module.exports = doc
  
